import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useReveal, useBentoGlow } from '../hooks/useScrollReveal';
import '../styles/Contact.css';

const fadeUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };

const Contact = () => {
    const [ref, isVisible] = useReveal();
    const glowRef = useBentoGlow();
    const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://formsubmit.co/ajax/sipalingnanda@gmail.com', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    name: form.name,
                    email: form.email,
                    subject: form.subject,
                    message: form.message,
                    _subject: `New Portfolio Message from ${form.name}`
                })
            });
            
            if (response.ok) {
                alert('Thank you for your message! I will get back to you soon.');
                setForm({ name: '', email: '', subject: '', message: '' });
            } else {
                alert('Oops! Something went wrong. Please try again or email me directly.');
            }
        } catch (error) {
            alert('Oops! Network error. Please try again.');
        }
    };

    const links = [
        { title: 'Email', value: 'sipalingnanda@gmail.com', link: 'mailto:sipalingnanda@gmail.com', icon: '/email.webp' },
        { title: 'Location', value: 'Sidoarjo, Jawa Timur', link: 'https://maps.app.goo.gl/TVisfw64uZPVJ4qK7', icon: '/loc.webp' },
        { title: 'LinkedIn', value: 'Nanda', link: 'https://linkedin.com/in/priyoga-listyo-ananda', icon: '/link.webp' },
        { title: 'GitHub', value: 'nandanannn24', link: 'https://github.com/nandanannn24', icon: '/github.webp' },
    ];

    return (
        <section id="contact" className="contact" ref={ref}>
            <div className="container" ref={glowRef}>
                {isVisible && (
                    <motion.div
                        className="contact-grid"
                        initial="hidden"
                        animate="visible"
                        variants={{ visible: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } } }}
                    >
                        {/* Header Cell */}
                        <motion.div className="bento-card section-header-card contact-header" variants={fadeUp}>
                            <span className="section-label">Contact</span>
                            <h2 className="section-heading">
                                Let's <span className="gradient-text">Connect</span>
                            </h2>
                            <p className="section-desc">
                                Have a project in mind or just want to say hello?
                            </p>
                        </motion.div>

                        {/* Info */}
                        <motion.div className="bento-card contact-info" variants={fadeUp} transition={{ duration: 0.5 }}>
                            <h3>Contact Information</h3>
                            <p className="contact-info-sub">Feel free to reach out through any channel.</p>
                            <div className="contact-links">
                                {links.map((item, i) => (
                                    <motion.a
                                        key={i}
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="contact-link"
                                        whileHover={{ x: 4, transition: { duration: 0.15 } }}
                                    >
                                        <div className="contact-link-icon">
                                            <img src={item.icon} alt={item.title} onError={(e) => { e.target.style.display = 'none'; }} />
                                        </div>
                                        <div>
                                            <h4>{item.title}</h4>
                                            <p>{item.value}</p>
                                        </div>
                                    </motion.a>
                                ))}
                            </div>
                        </motion.div>

                        {/* Form */}
                        <motion.div className="bento-card contact-form" variants={fadeUp} transition={{ duration: 0.5 }}>
                            <h3>Send a Message</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="contact-name">Name</label>
                                        <input id="contact-name" type="text" name="name" placeholder="Your name" value={form.name} onChange={handleChange} required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="contact-email">Email</label>
                                        <input id="contact-email" type="email" name="email" placeholder="your@email.com" value={form.email} onChange={handleChange} required />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="contact-subject">Subject</label>
                                    <input id="contact-subject" type="text" name="subject" placeholder="What's this about?" value={form.subject} onChange={handleChange} required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="contact-message">Message</label>
                                    <textarea id="contact-message" name="message" placeholder="Tell me about your project..." rows="5" value={form.message} onChange={handleChange} required />
                                </div>
                                <div className="form-submit">
                                    <motion.button type="submit" className="btn primary" whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                                        Send Message <span className="arrow">→</span>
                                    </motion.button>
                                </div>
                            </form>
                        </motion.div>
                    </motion.div>
                )}
            </div>
        </section>
    );
};

export default Contact;